import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const EtlSummaryCardStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "etl-summary-card-styled",
})`
  margin-top: 24px;
  border: 1px solid ${rydeColors.lightGreyBorder};
  border-radius: 12px;
  overflow: hidden;
  background: ${rydeColors.white};
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);

  .header {
    padding: 16px 24px;
    color: ${rydeColors.white};
    background: linear-gradient(
      135deg,
      ${rydeColors.steel},
      ${rydeColors.darkSteel}
    );

    &__title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 18px;
      font-weight: 700;
    }

    &__meta {
      margin-top: 10px;
      opacity: 0.9;
      font-size: 14px;
    }

    &__meta-item {
      display: inline-flex;
      align-items: center;
      gap: 10px;
    }
  }

  .body {
    padding: 20px 24px;
  }

  .stats {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .stat {
    flex: 1 1 130px;
    min-width: 130px;
    padding: 16px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;

    &__label {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.4px;
    }

    &__value {
      font-size: 26px;
      font-weight: 700;
      line-height: 1;
    }

    &--existing {
      background: rgba(61, 112, 178, 0.1);
    }
    &--existing .stat__label,
    &--existing .stat__value {
      color: ${rydeColors.steel};
    }

    &--new {
      background: rgba(5, 154, 143, 0.1);
    }
    &--new .stat__label,
    &--new .stat__value {
      color: ${rydeColors.green};
    }

    &--removed {
      background: rgba(187, 36, 36, 0.1);
    }
    &--removed .stat__label,
    &--removed .stat__value {
      color: ${rydeColors.crisisRed};
    }

    &--duration {
      background: rgba(255, 138, 0, 0.1);
    }
    &--duration .stat__label,
    &--duration .stat__value {
      color: ${rydeColors.orange};
    }
  }

  .detail {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid ${rydeColors.lightGreyBorder};

    &__label {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
    }
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .chip {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border: 1px solid ${rydeColors.green};
    color: ${rydeColors.green};
    border-radius: 16px;
    font-family: inherit;
    font-size: 13px;
    background: rgba(5, 154, 143, 0.06);

    &--clickable {
      cursor: pointer;
      transition: background 0.15s ease;

      &:hover {
        background: rgba(5, 154, 143, 0.16);
      }
    }
  }

  .empty {
    color: ${rydeColors.grey};
  }
`;
